import { __decorate, __rest } from "tslib";
/**
 *  交易完结
 */
import React, { Component } from 'react';
import { Table, Button, message, Row, Col, Select, Form, DatePicker, Modal } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, UnitSearch, DealType, showUserInfo, BuyerDistributor } from '@/components';
import { dispatch } from '@@/store';
import styled from 'styled-components';
import { dealListValueShow, dealValueShow, thousandBitSeparator } from '@/shared/functions';
import { showCarDetail } from '@/components/CarDetail';
import moment from 'moment';
import { dealTimeAnotherLine } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
import Authorized from '@/components/Auth/auth';
import OpreateShowMore from '@/components/OperateShowMore';
import { dealTableScroll } from '@/pages/CarManage/_components/function';
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
const Root = styled.span `
  button.ant-btn.ant-btn-primary[disabled] {
    opacity: 0.5;
    color: #fff;
    border-color: #ff571a;
  }
`;
// @ts-ignore
let TradeSuccessTable = class TradeSuccessTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clipped: [
                { dataIndex: 'carVin' },
                { dataIndex: 'carLicense' },
                { dataIndex: 'carLocation' },
                { dataIndex: 'buyerTypeName' },
                { dataIndex: 'buyerTypeName' },
            ],
            colums: [
                {
                    title: props.isOrder ? '订单信息' : '车辆信息',
                    dataIndex: 'carMsg',
                    width: 400,
                    fixed: 'left',
                    render: (carMsg, rowData, index) => {
                        const { firstImage, goodsName, goodsId, carVin, carLicense, carLocation, rankDesc, rankLevel, reportType, orderId } = rowData;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={goodsName}/>
                </div>
                <div>
                  {props.isOrder && <div>
                      订单号：{orderId || fontEndConfig.noValueReplace}
                    </div>}
                  <div>
                    {goodsName ? <a onClick={() => {
                            showCarDetail(goodsId);
                        }}>
                        {goodsName}
                      </a> : fontEndConfig.noValueReplace}
                  </div>
                  <div>{`VIN码：${carVin}`}</div>
                  <div>
                    {reportType === 1 &&
                            <img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>}
                    <div className={'tag_item'}>{carLicense}</div>
                    <div className={'tag_item'}>{carLocation}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                    <div className={'tag_item'}>{this.getDealType(rowData.sourceType)}</div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '买卖家信息',
                    dataIndex: 'buyerSellerMsg',
                    width: 250,
                    render: (data, record, index) => {
                        const { buyerTypeName, sellerName } = record;
                        return (<div>
                <div>{`买家类型：${buyerTypeName}`}</div>
                <BuyerDistributor record={record}/>
                <div>
                  <span>卖家经销商：</span>
                  {sellerName ? <a onClick={() => {
                            showInfo('seller', record.sellerCode);
                        }}>
                      {sellerName}
                    </a> : fontEndConfig.noValueReplace}
                </div>
              </div>);
                    },
                },
                {
                    title: '价格信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'priceMsg',
                    width: 250,
                    render: (data, record, index) => {
                        return (<div>
                <div>{`成交价：${thousandBitSeparator(record.sellerPriceYuanUnit)}`}</div>
                <div>{`合手价：${thousandBitSeparator(record.totalPriceYuanUnit)}`}</div>
                <div style={{
                            fontSize: '10px',
                        }}>
                  {`佣金：${thousandBitSeparator(record.brokerageYuanUnit)}`}
                  &nbsp;&nbsp;
                  {`服务费：${thousandBitSeparator(record.commissionYuanUnit)}`}
                </div>
              </div>);
                    },
                },
            ],
            changeColumn: {
                dealSuccessTime: {
                    title: '交易成功时间',
                    dataIndex: 'overTime',
                    width: 150,
                    render: (overTime) => {
                        return overTime ? (dealTimeAnotherLine(overTime)) : fontEndConfig.noValueReplace;
                    },
                },
                applyTime: {
                    title: '申请时间',
                    width: 150,
                    dataIndex: 'orderPayCreateTime',
                    render: (orderPayCreateTime) => {
                        return orderPayCreateTime ? (dealTimeAnotherLine(orderPayCreateTime)) : fontEndConfig.noValueReplace;
                    },
                },
                rejectTime: {
                    title: '驳回时间',
                    dataIndex: 'payOverTime',
                    width: 150,
                    render: (payOverTime) => {
                        return payOverTime ? (dealTimeAnotherLine(payOverTime)) : fontEndConfig.noValueReplace;
                    },
                },
                payShow: {
                    title: '操作',
                    dataIndex: 'operation',
                    width: 150,
                    fixed: 'right',
                    render: (text, record, index) => {
                        const { payStatus, payApprovalStatus } = record;
                        return (<OpreateShowMore>
                {(payStatus === 0 && (payApprovalStatus === 0 || payApprovalStatus === 3)) &&
                            <Authorized allow={'psgjb-ordervolume-pay'}>
                    <a onClick={() => {
                                this.applyPay([record.orderId]);
                            }} luban-id="PSGJB-ORDER-JYCGCL-SQFK">
                      申请向卖家付款
                    </a>
                  </Authorized>}
                <Authorized>
                  <a onClick={(event) => {
                            showUserInfo(record);
                        }}>
                    查看过户信息
                  </a>
                </Authorized>
                <a onClick={(event) => {
                            dispatch.router.push({
                                path: '/carManage/offerdetails',
                                query: {
                                    id: record.auctionId,
                                },
                            });
                        }}>
                  出价详情
                </a>
              </OpreateShowMore>);
                    },
                },
                guHuJieSuanShow: {
                    title: '操作',
                    dataIndex: 'operate',
                    width: 150,
                    fixed: 'right',
                    render: (text, record, index) => (<OpreateShowMore>
              <Authorized>
                <a onClick={(event) => {
                        showInfo('settle', record.orderId);
                    }} luban-id="PSGJB-ORDER-JYCGCL-SQFK">
                  结算信息查看
                </a>
              </Authorized>
              <Authorized>
                <a style={{ display: 'block' }} href="javascript:;" onClick={(event) => {
                        showUserInfo(record);
                    }}>
                  过户信息查看
                </a>
              </Authorized>
            </OpreateShowMore>),
                },
                guoHuShow: {
                    title: '操作',
                    dataIndex: 'operate',
                    width: 150,
                    fixed: 'right',
                    render: (text, record) => (<OpreateShowMore>
              <Authorized>
                <a style={{ display: 'block' }} href="javascript:;" onClick={(event) => {
                        showUserInfo(record);
                    }}>
                  查看过户信息
                </a>
              </Authorized>
            </OpreateShowMore>),
                },
                passTime: {
                    title: '通过时间',
                    dataIndex: 'payOverTime',
                    width: 150,
                    render: (payOverTime) => {
                        return payOverTime ? (dealTimeAnotherLine(payOverTime)) : fontEndConfig.noValueReplace;
                    },
                },
            },
            checkedKey: [],
            globalSearch: {},
            privateSearch: {
                statusCode: 51,
                unitSearch: undefined,
            },
            stateList: [
                {
                    label: '待申请',
                    key: 51,
                },
                {
                    label: '申请中',
                    key: 52,
                },
                {
                    label: '已驳回',
                    key: 54,
                },
                {
                    label: '已通过',
                    key: 53,
                },
            ],
            unitList: [
                {
                    label: '买家经销商名称',
                    key: 'buyerName',
                },
                {
                    label: '买家经销商电话',
                    key: 'buyerPhone',
                },
            ],
            userTypeList: [
                {
                    label: '全部',
                    key: 2,
                },
                {
                    label: '网络',
                    key: 1,
                },
                {
                    label: '现场',
                    key: 0,
                },
            ],
        };
        this.onSelectedTableItem = this.onSelectedTableItem.bind(this);
        this.applyPay = this.applyPay.bind(this);
        this.multipleAgree = this.multipleAgree.bind(this);
    }
    applyPay(orderIdList) {
        Modal.confirm({
            title: '是否确定申请向卖家付款',
            onOk: () => {
                dispatch.carOperate.applyToSellerPay({
                    idList: orderIdList,
                    callback: (state) => {
                        state && this.updateTable();
                        this.setState({
                            checkedKey: [],
                        });
                    },
                });
            },
        });
    }
    componentDidMount() {
        this.props.isOrder ? dispatch.winBiddingCar.getOrderCountInfoApi({}) : dispatch.carState.getEveryStateCarNum({});
        this.searchData(Object.assign({}, this.props.search));
    }
    // 成交状态
    getDealType(data) {
        switch (data) {
            case 1:
                return '流拍撮合';
            case 2:
                return '撮合成交';
            case 0:
            default:
                return '正常成交';
        }
    }
    // desc更新表格内容
    updateTable(index) {
        dispatch.carState.updateDealEndTable(index || 0);
    }
    // desc 选中表格checkboxs
    onSelectedTableItem(selectedRowKeys, selectedRows) {
        let selectedList = selectedRowKeys;
        if (selectedRowKeys.length > 100) {
            message.warning('最多选择100条');
            selectedList = selectedRowKeys.slice(0, 100);
        }
        this.setState({
            checkedKey: selectedList,
        });
    }
    // desc 批量申请向卖家付款
    multipleAgree() {
        const data = this.state.checkedKey;
        this.applyPay(data);
    }
    search() {
        const { globalSearch, privateSearch } = this.state;
        const { unitSearch, startTime, endTime } = privateSearch, otherPrivate = __rest(privateSearch, ["unitSearch", "startTime", "endTime"]);
        let dealSearch = {};
        if (startTime && endTime) {
            const { statusCode } = otherPrivate;
            switch (statusCode) {
                case 51:
                case 52:
                    dealSearch = Object.assign(Object.assign({}, dealSearch), { overTimeDateStar: startTime, overTimeDateEnd: endTime });
                    break;
                case 54:
                case 53:
                    dealSearch = Object.assign(Object.assign({}, dealSearch), { sellerPayFinishDateStar: startTime, sellerPayFinishDateEnd: endTime });
                    break;
            }
        }
        const params = Object.assign(Object.assign(Object.assign(Object.assign({}, globalSearch), unitSearch), dealSearch), otherPrivate);
        dispatch.carState.SET_STATE({
            searchData: params,
        });
        dispatch.carState.updateDealEndTable(1);
    }
    searchData(searchData) {
        const { isOrder } = this.props;
        const { vin } = searchData, otherSearch = __rest(searchData, ["vin"]);
        this.setState({
            globalSearch: isOrder ? searchData : Object.assign(Object.assign({}, otherSearch), { vinCode: vin }),
        }, () => {
            this.search();
        });
    }
    render() {
        const { tableData, isLoading, pageIndex, pageSize, tableTotal, searchData } = this.props.carState;
        const { colums, checkedKey, privateSearch, stateList, unitList, userTypeList, clipped } = this.state;
        const { statusCode } = privateSearch;
        const { dealSuccessTime, applyTime, rejectTime, payShow, guoHuShow, passTime, guHuJieSuanShow } = this.state.changeColumn;
        let tableHead = [];
        let timeLabel;
        let exportType = '';
        switch (statusCode) {
            case 51:
                timeLabel = '交易成功时间';
                tableHead = [...colums, dealSuccessTime, payShow];
                exportType = 'transaction_pay_wait_apply';
                break;
            case 52:
                timeLabel = '交易成功时间';
                tableHead = [...colums, dealSuccessTime, applyTime, guoHuShow];
                exportType = 'transaction_pay_apply_ing';
                break;
            case 54:
                timeLabel = '驳回时间';
                tableHead = [...colums, rejectTime, payShow];
                exportType = 'transaction_pay_refund';
                break;
            case 53:
                timeLabel = '通过时间';
                tableHead = [...colums, passTime, guHuJieSuanShow];
                exportType = 'transaction_pay_pass';
                break;
        }
        const { dealColumns, scrollX } = dealTableScroll(tableHead);
        return (<React.Fragment>
        <Row gutter={16} align={'middle'} type={'flex'} justify={'start'} style={{
            marginBottom: '22px',
        }}>
          {stateList.map(({ label, key }) => {
            return (<Button key={`btn_${key}`} type={statusCode === key ? 'primary' : undefined} style={{
                border: 0,
            }} onClick={() => {
                const { privateSearch, checkedKey } = this.state;
                this.setState({
                    privateSearch: Object.assign(Object.assign({}, privateSearch), { statusCode: key }),
                    checkedKey: key !== 51 ? [] : checkedKey,
                }, () => {
                    this.search();
                });
            }}>
                  {label}
                </Button>);
        })}
          <Col span={6}>
            <UnitSearch queryList={unitList} onChange={(val) => {
            const searchData = this.state.privateSearch;
            // const { privateSearch } = this.state;
            const unitSearch = {};
            if (val) {
                const [searchKey, searchContent] = val.split('_');
                unitSearch[searchKey] = searchContent;
            }
            this.setState({
                privateSearch: Object.assign(Object.assign({}, searchData), { unitSearch }),
            }, () => {
                this.search();
            });
        }}/>
          </Col>
        </Row>
        <TableContainer hasExport={true} exportObj={{
            type: 'order',
            params: Object.assign(Object.assign({}, searchData), { totalCount: tableTotal, exportType }),
            fileName: this.props.isOrder ? '订单管理-交易完结' : '车辆管理-交易完结',
            allow: this.props.isOrder ? 'psgjb-ordertransfer-jiaoyiwanjieexport' : 'psgjb-carpendcjjywj-export',
        }}>
          <div style={{
            marginRight: '100px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        }}>
            {statusCode === 51 ?
            <Root>
                  <span style={{ marginRight: 12 }}>已选择{checkedKey.length}条</span>
                  <Button type="primary" disabled={checkedKey.length === 0} style={{ backgroundColor: '#ff571a', marginRight: 12 }} onClick={this.multipleAgree}>
                    批量申请
                  </Button>
                </Root>
            :
                <div />}
            <Row style={{
            width: '80%',
        }} gutter={16} align={'middle'} type={'flex'}>
              <Col span={10} offset={2}>
                <Form.Item label={timeLabel} colon={false} className={'search_time_label_border'}>
                  <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            let [startTime, endTime] = dates;
            startTime && (startTime = startTime.format('YYYY-MM-DD'));
            endTime && (endTime = endTime.format('YYYY-MM-DD'));
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { startTime,
                    endTime }),
            }, () => {
                this.search();
            });
        }}/>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Select style={{
            width: '100%',
        }} placeholder={'请选择买家类型'} onChange={(val) => {
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { buyerTypeCode: val }),
            }, () => {
                this.search();
            });
        }}>
                  {userTypeList.map(({ label, key }) => {
            return (<Select.Option value={key} key={key}>{label}</Select.Option>);
        })}
                </Select>
              </Col>
              <Col span={6}>
                <DealType style={{
            width: '100%',
        }} placeholder={'请选择成交类型'} onChange={(val) => {
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { sourceType: val }),
            }, () => {
                this.search();
            });
        }}/>
              </Col>
            </Row>
          </div>
          <Table loading={isLoading} className={statusCode === 51 ? 'draw_table_all_border draw_table_checkbox scroll_table' : 'draw_table_all_border scroll_table'} columns={dealColumns} dataSource={dealListValueShow({
            gistData: clipped,
            data: tableData,
        })} rowKey={'orderId'} rowSelection={statusCode === 51 ? {
            selectedRowKeys: checkedKey,
            onChange: this.onSelectedTableItem,
            getCheckboxProps: record => ({
                disabled: (record.payStatus === 0 && (record.payApprovalStatus === 0 || record.payApprovalStatus === 3)) ? false : true,
            }),
        } : undefined} scroll={{
            x: scrollX,
        }} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: tableTotal,
            onChange: this.updateTable,
            showTotal: total => `共${total}条`,
        }}/>
        </TableContainer>
      </React.Fragment>);
    }
};
TradeSuccessTable.defaultProps = {
    isOrder: false,
};
TradeSuccessTable = __decorate([
    connect(mapStateToProps, null, null, { forwardRef: true })
], TradeSuccessTable);
export default TradeSuccessTable;
